import styled from 'styled-components';

import type { Sport } from '@sorare/core/src/__generated__/globalTypes';
import {
  Rarity,
  SeasonEligibility,
} from '@sorare/core/src/__generated__/globalTypes';
import { Horizontal } from '@sorare/core/src/atoms/layout/flex';
import type { StatsRarity } from '@sorare/core/src/lib/playerSearchView';

import { SelectRarity } from '#src/atoms/SelectRarity/index.tsx';
import { TextSwitchSeasonality } from '#src/atoms/TextSwitchSeasonality/index.tsx';
import { Block } from '#src/components/player/PlayerMarketDrawer/ui.tsx';
import { usePlayerPageFilters } from '#src/hooks/usePlayerPageFilters.ts';
import type { SeasonEligibilityOptions } from '#src/lib/seasonalities.ts';
import { ALL_VALUE } from '#src/lib/seasonalities.ts';

const StyledBlock = styled(Block)`
  background-color: var(--c-black);
  position: sticky;
  top: 0;
  z-index: 1;
  .PLAYER_PAGE & {
    padding: var(--double-unit) var(--double-unit) var(--unit);
  }
`;

const Row = styled(Horizontal)`
  width: 100%;
`;
const Grow = styled.div`
  flex-grow: 1;
`;
const rarities: StatsRarity[] = [
  Rarity.limited,
  Rarity.rare,
  Rarity.super_rare,
  Rarity.unique,
];

type Props = {
  filters: {
    rarity: StatsRarity;
    seasonality: SeasonEligibilityOptions;
  };
  setFilters: (filters: {
    rarity: StatsRarity;
    seasonality: SeasonEligibilityOptions;
  }) => void;
  sport: Sport;
};
export const PlayerPageHeader = ({ filters, setFilters, sport }: Props) => {
  const { rarity, seasonality } = filters;
  const { setFilters: setPlayerPageFilters } = usePlayerPageFilters(sport);

  const onRarityChange = (r: StatsRarity) => {
    setFilters({ ...filters, rarity: r });
    setPlayerPageFilters({ ...filters, rarity: r });
  };

  const onSeasonalityChange = (s: SeasonEligibilityOptions) => {
    if (s !== ALL_VALUE) {
      setFilters({ ...filters, seasonality: s });
      setPlayerPageFilters({ ...filters, seasonality: s });
    }
  };

  return (
    <StyledBlock>
      <Row>
        <Grow>
          <TextSwitchSeasonality
            seasonalities={[
              SeasonEligibility.IN_SEASON,
              SeasonEligibility.CLASSIC,
            ]}
            seasonality={seasonality}
            setSeasonality={onSeasonalityChange}
            withLabel
            forceDesktopLayout
            onlyGrowOnSelected
          />
        </Grow>
        <SelectRarity
          rarities={rarities}
          selectedRarity={rarity}
          onChange={onRarityChange}
          buttonSize="compact"
        />
      </Row>
    </StyledBlock>
  );
};
